import React from 'react';
const modules = [{
  title: 'Clinical Assessment System™',
  description: 'Professional assessment resources for initial evaluations, subjective assessments, pain assessment, ROM, strength, balance, gait, functional movement, outcome tracking, and progress evaluation.'
}, {
  title: 'Exercise Prescription Library™',
  description: 'A structured visual library of therapeutic exercises covering cervical, shoulder, thoracic, lumbar, hip, knee, ankle, balance, core, and functional strength—with exercise demonstrations, dosage guidance, progressions, regressions, therapist cues, and clinical notes.'
}, {
  title: 'Rehabilitation Programs™',
  description: 'Structured rehabilitation frameworks for common clinical presentations, with organized progressions to help plan, adapt, and monitor rehabilitation more efficiently.'
}, {
  title: 'Treatment Planning Toolkit™',
  description: 'Professional session planners, treatment plans, progression frameworks, home exercise planning resources, goal-setting sheets, follow-up templates, patient roadmaps, treatment timelines, and clinical workflow tools.'
}, {
  title: 'Patient Education Resources™',
  description: 'Ready-to-use patient resources covering pain education, home exercise instructions, posture, recovery guidance, pain management, and activity modification.'
}, {
  title: 'Clinical Documentation Kit™',
  description: 'Professional documentation resources including SOAP notes, daily notes, progress notes, initial evaluations, reassessments, consent forms, referrals, discharge summaries, goal tracking, appointment records, follow-ups, and clinical checklists.'
}];
const steps = ['OPEN', 'CHOOSE', 'ADAPT', 'USE'];
export function ModulesSection() {
  return <section className="py-10 px-4 sm:px-6 bg-brand-navy text-white" data-id="element-129" data-mp="h76amprdu703">
      <div className="text-center mb-8" data-id="element-130" data-mp="l7zzblcnfpu1">
        <h2 className="text-2xl sm:text-3xl font-heading font-black text-white mb-3 uppercase leading-tight" data-id="element-131" data-mp="l6ykr6wfcl7k">
          EVERYTHING YOU NEED. ONE COMPLETE CLINICAL SYSTEM.
        </h2>
        <p className="text-sm sm:text-base font-bold text-brand-gold mb-4 uppercase tracking-wide" data-id="element-132" data-mp="2j2nclpoqmahr">
          6 Professional Clinical Resources In One Organized System
        </p>
        <div className="inline-block bg-brand-gold/20 text-brand-gold px-4 py-2 rounded-lg mb-4 border border-brand-gold/30" data-id="element-133" data-mp="2960sj348jngs">
          <p className="font-bold text-xs sm:text-sm tracking-wide uppercase" data-id="element-134" data-mp="36shn40ll3myu">
            🩺 PHYSIO READY™ — Complete 6-in-1 Clinical Resource System
          </p>
        </div>
        <p className="text-sm sm:text-base text-white/80 leading-relaxed max-w-2xl mx-auto font-medium" data-id="element-135" data-mp="2wtsg52v87mxd">
          Physio Ready™ brings the essential resources of your clinical workflow
          together in one organized system. From assessment and exercise
          prescription to rehabilitation planning, patient education, progress
          tracking, and documentation, you get structured professional resources
          ready to use, print, and adapt to your patients.
        </p>

        <div className="mt-5 max-w-lg mx-auto bg-white rounded-lg px-3 py-3" data-id="element-136" data-mp="wun0sx1zuf8">
          <ol className="flex items-center justify-center gap-1.5 sm:gap-3 font-heading font-black text-sm sm:text-lg text-brand-navy" data-id="element-137" data-mp="5wz2cfm86j3v">
            {steps.map((step, i) => <li key={step} className="flex items-center gap-1.5 sm:gap-3" data-id="element-138" data-mp="apa47o0j0ez2" data-mpi={i}>
                <span data-id="element-139" data-mp="fm8vlyst27tk">{step}</span>
                {i < steps.length - 1 && <span className="text-brand-gold" aria-hidden="true" data-id="element-140" data-mp="kkadigehw13g">→</span>}
              </li>)}
          </ol>
        </div>
        <p className="text-xs sm:text-sm text-white/70 mt-3 max-w-xl mx-auto" data-id="element-141" data-mp="tmbdhl14518t">
          Spend less time searching and preparing—and more time focused on the
          patient in front of you.
        </p>
      </div>

      <div className="grid grid-cols-1 md:grid-cols-2 gap-3 sm:gap-4 max-w-4xl mx-auto" data-id="element-142" data-mp="2vd4veeykpujz">
        {modules.map(module => <div key={module.title} className="bg-brand-navy-dark p-5 rounded-xl flex flex-col gap-2.5 border border-white/10" data-id="element-143" data-mp="2026nxgtuowzq">
            <div className="flex items-center gap-3" data-id="element-144" data-mp="2a1e1o54hytnd">
              <div className="shrink-0 w-7 h-7 flex items-center justify-center rounded-full font-black text-sm text-white bg-brand-sage" data-id="element-145" data-mp="2a0w8xih1mxk7">
                ✓
              </div>
              <h3 className="text-sm sm:text-base font-bold leading-tight text-white uppercase" data-id="element-146" data-mp="1hds012etxz35">
                {module.title}
              </h3>
            </div>
            <p className="text-white/70 text-sm leading-relaxed" data-id="element-147" data-mp="1r2jov1olg39u">
              {module.description}
            </p>
          </div>)}
      </div>
    </section>;
}